import _ from 'lodash';

export const isDefined = (value) => {
    return !_.isUndefined(value) && !_.isNull(value) && !_.isNaN(value);
};
